import * as emailTemplateService from '../../services/emailTemplate.service';


const state = {
    emailTemplatePaginate:{},
    emailTemplatePaginateData:{},
    emailTemplateDropdownList:[],
};

const getters = {
    getEmailTemplatePaginate:state => (state.emailTemplatePaginate),
    getEmailTemplatePaginateData:state => (state.emailTemplatePaginateData),
    getEmailTemplateDropdownList:state => (state.emailTemplateDropdownList),
};

const actions = {
    async fetchEmailTemplatePaginate({ commit }, obj){
      commit('setEmailTemplatePaginate', obj)
      try {
          const response = await emailTemplateService.listPage(obj);
          commit('setEmailTemplatePaginateData', response.data);
      } catch (error) {
          console.log('something wrong - fetchEmailTemplatePaginate', error);
      }
    },

    async fetchEmailTemplateDropdownList({ commit }, obj){
      try {
          const response = await emailTemplateService.dropdownList(obj);
          commit('setEmailTemplateDropdownList', response.data);
      } catch (error) {
          console.log('something wrong - fetchEmailTemplateDropdownList', error);
      }
    },
};

const mutations = {
  setEmailTemplatePaginateData:(state, res) => (
    state.emailTemplatePaginateData =  res
  ),
  setEmailTemplatePaginate:(state, res) => (
      state.emailTemplatePaginate =  res
  ),
  setEmailTemplateDropdownList:(state, res) => (
    state.emailTemplateDropdownList =  res
  ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}
